import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import NavLink from 'garaje/pods/components/nav-link/component';
import type GlobalOverviewAccessService from 'garaje/services/global-overview-access';

interface GlobalLocationSignature {
  Args: {
    isLocationsOpen: boolean;
    trackClickEvent: (trackingString: string) => void;
  };
}

export default class GlobalLocation extends Component<GlobalLocationSignature> {
  @service declare globalOverviewAccess: GlobalOverviewAccessService;

  <template>
    {{#if this.globalOverviewAccess.canVisitGlobalLocation}}
      <li>
        <NavLink
          @route="location-overview.locations"
          @current-when={{@isLocationsOpen}}
          class="icon-mainNav-locations flex font-bold py-2"
          {{on "click" (fn @trackClickEvent "SideBar-Global-Locations")}}
          data-test-locations-nav
        >
          Locations
        </NavLink>
      </li>
    {{/if}}
  </template>
}
